module.exports = __webpack_public_path__ + "img/bus-green.94080396.svg";